import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { getProducts, fromWcProduct } from '../../../lib/wp-api';
import { useCart } from '../../../context/CartContext';

const OnSale = () => {
  const navigate = useNavigate();
  const cart = useCart();

  const handleAddToCart = (e, product) => {
    e.stopPropagation();
    cart.addItem(product, 1);
  };
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    getProducts({ per_page: 8, tag: 'sale' })
      .then((rows) => { if (!cancelled) setProducts(rows.map(fromWcProduct)); })
      .catch(() => { if (!cancelled) setProducts([]); });
    return () => { cancelled = true; };
  }, []);

  const handleProductClick = (product) => {
    navigate(`/product-details?id=${product?.id}`);
  };

  const handleViewAll = () => {
    navigate('/product-catalog?filter=sale');
  };

  if (!products.length) return null;

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <motion.h2
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-2">
              On Sale Now
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="text-lg text-muted-foreground">
              Save on selected pieces — while they last
            </motion.p>
          </div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}>
            <Button onClick={handleViewAll} variant="outline" className="hidden md:flex items-center gap-2">
              View All
              <Icon name="ArrowRight" size={16} />
            </Button>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products?.map((product, index) =>
            <motion.div
              key={product?.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              onClick={() => handleProductClick(product)}
              className="cursor-pointer group">
              <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="relative overflow-hidden aspect-square">
                  <img src={product?.image} alt={product?.alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  {product?.discount > 0 && (
                    <div className="absolute top-3 left-3">
                      <span className="bg-red-500 text-white text-xs font-semibold px-3 py-1 rounded-full">
                        -{product.discount}%
                      </span>
                    </div>
                  )}
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-semibold text-foreground mb-2 line-clamp-1">{product?.name}</h3>
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-2xl font-bold text-foreground">${product?.price}</span>
                    {product?.originalPrice > 0 && (
                      <span className="text-sm text-muted-foreground line-through">${product.originalPrice}</span>
                    )}
                  </div>
                  <Button size="sm" className="opacity-0 group-hover:opacity-100 transition-opacity" onClick={(e) => handleAddToCart(e, product)}>Add to Cart</Button>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default OnSale;
